import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdateAuthorizedDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import { Option } from '../Selects/Selector';
import CompanySelector from '../Selects/CompanySelector';
import EmployeeSelector from '../Selects/EmployeeSelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import CurrencyControl from '../../../app/components/CurrencyControl';
import TeamSelector from '../Selects/TeamSelector';
import { NewDatePicker } from '../../../app/components/NewDatePicker';
import { handleChangeSelection } from '../Selects/selectUtils';

interface AuthorizedEditorFormProps {
  authorized: CreateUpdateAuthorizedDto;
  propertyChange: (obj: Partial<CreateUpdateAuthorizedDto>) => void;
  readOnly?: boolean;
  creatingAuthorized?: boolean;
}

export const AuthorizedEditorForm: React.FC<
  AuthorizedEditorFormProps
> = props => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <>
      <Form className="d-grid gap-3">
        <FormRow controlId="employee" label={t(tk.common.employee)}>
          <EmployeeSelector
            value={props.authorized?.employeeId || ''}
            onChange={option =>
              handleChangeSelection(option, 'employeeId', props.propertyChange)
            }
            withOneToolId={true}
            readOnly={props.readOnly}
          />
        </FormRow>
        <FormRow controlId="company" label={t(tk.common.company)}>
          <CompanySelector
            value={props.authorized?.companyId}
            onChange={e => {
              props.propertyChange({
                companyId: (e as Option)?.value,
              });
            }}
            readOnly={props.readOnly}
          />
        </FormRow>
        <FormRow controlId="team" label={t(tk.common.team)}>
          <TeamSelector
            value={props.authorized?.teamId || ''}
            companyId={props.authorized?.companyId || ''}
            onChange={e => {
              props.propertyChange({
                teamId: (e as Option)?.value,
              });
            }}
            clearable={true}
          />
        </FormRow>
        <FormRow controlId="amount" label={t(tk.common.amount)}>
          <CurrencyControl
            decimalScale={2}
            value={props.authorized?.maxAmount}
            onChange={value =>
              props.propertyChange({
                maxAmount: value || undefined,
              })
            }
            disabled={props.readOnly}
          />
        </FormRow>
        <FormRow controlId="endDate" label={t(tk.common.endDate)}>
          <NewDatePicker
            value={props.authorized?.endDate}
            dateChanged={d => props.propertyChange({ endDate: d })}
            readOnly={props.readOnly}
          />
        </FormRow>
        {!props.readOnly && (
          <FormRow controlId="active" label={t(tk.common.activeHe)}>
            <Form.Check
              type="checkbox"
              className="pt-2"
              checked={props.authorized?.active ?? true}
              onChange={e => props.propertyChange({ active: e.target.checked })}
              disabled={props.readOnly}
            />
          </FormRow>
        )}
      </Form>
    </>
  );
};
